import { render, staticRenderFns } from "./HomeRecommend.vue?vue&type=template&id=6c9c2a14"
import script from "./HomeRecommend.vue?vue&type=script&lang=js"
export * from "./HomeRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports